import React from 'react'
import { TextField } from '@diversioteam/diversio-ds'

import { FieldWrapper } from './../FieldWrapper'
import { ParagraphInactive } from './paragraphInactive'
import { ParagraphProps } from './paragraph.types'
import * as S from './../fields.styles'

export const Paragraph = ({
    item,
    isActive,
    isDeleteElementButtonDisabled,
    onAddElement,
    onChangeElementValue,
    onDeleteElement,
    onToggleRequired,
    onChangeElementType,
    onDuplicateElement,
    onChangeActiveElement,
    previewMode,
}: ParagraphProps) => {
    if (previewMode) {
        return <ParagraphInactive item={item} previewMode={previewMode} />
    }

    if (!isActive) {
        return <ParagraphInactive item={item} onClick={() => onChangeActiveElement(item.id)} />
    }

    return (
        <FieldWrapper
            item={item}
            isActive={isActive}
            isDeleteElementButtonDisabled={isDeleteElementButtonDisabled}
            onAddElement={onAddElement}
            onChangeElementValue={onChangeElementValue}
            onDeleteElement={onDeleteElement}
            onToggleRequired={onToggleRequired}
            onChangeElementType={onChangeElementType}
            onDuplicateElement={onDuplicateElement}
            onChangeActiveElement={onChangeActiveElement}
        >
            <S.OptionList>
                <S.OptionRow>
                    <TextField
                        name={`long-answer-${item.id}`}
                        aria-label="Long answer text"
                        placeholder="Long answer text"
                        defaultValue="Long answer text"
                        variant="standard"
                        fullWidth
                        disabled
                    />
                </S.OptionRow>
            </S.OptionList>
        </FieldWrapper>
    )
}
